export default __webpack_public_path__ + "static/media/64bd975b2f4881959b3b845fd7eaaed0.png";